// extracted by mini-css-extract-plugin
export default {"textareaWrapper":"Textarea_textareaWrapper__-LFyh","textarea":"Textarea_textarea__1wquP"};